// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiGet, BASE_URL, retrieveToken } from "../../store/api";
import { UserRoleListResponse } from "./types";

import * as userRoleActions from "./userRole.actions";

export function* getRoles(
  action: ReturnType<typeof userRoleActions.getRoleAsync.request>
) {
  try {
    const token: string = yield retrieveToken();
    const url = BASE_URL + 'roles';
    const result: Response = yield call(apiGet, url, token);

    if (result.status === 200) {
      const parsed: UserRoleListResponse = yield call(result.json.bind(result));
      yield put(userRoleActions.getRoleAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(userRoleActions.getRoleAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(userRoleActions.getRoleAsync.failure(parsed));
  }
}

export default function* userRoleSagaGetRoles() {
  yield takeEvery(userRoleActions.getRoleAsync.request, getRoles);
}
